import { render, staticRenderFns } from "./PagseguroCreditCard.vue?vue&type=template&id=6bf1612e"
import script from "./PagseguroCreditCard.vue?vue&type=script&lang=js"
export * from "./PagseguroCreditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports